import { motion, MotionConfig } from "framer-motion";
import Shape from "ui/atoms/Shape/Shape";
import { GameRound } from "shared/games/types/GameRound";
import useOnChangeHandler from "../../../../molecules/GameRoundBuilders/useOnChangeHandler";
import * as a from "../../animationConsts";
import { InstrumentsConfig } from "shared/games/instruments/instrumentsConfig";

interface Props {
  instruments: InstrumentsConfig;
  value: GameRound;
  changers: ReturnType<typeof useOnChangeHandler>;
}

export default function InstrumentSelector({
  instruments,
  value,
  changers,
}: Props) {
  return (
    <MotionConfig
      transition={{
        duration: 0.3,
        delay: 0.4,
      }}
    >
      <motion.div
        className="mb-6 flex items-center justify-between"
        initial={a.initial}
        exit={a.exit}
        animate={a.animate}
      >
        <div className="mr-5 font-brik text-lg leading-tight text-white">
          Select all of the instruments you want to practice in these games
        </div>
      </motion.div>

      <motion.div
        className="grid grid-cols-[repeat(auto-fit,minmax(75px,1fr))] gap-3"
        initial={a.initial}
        exit={a.exit}
        animate={a.animate}
      >
        {Object.values(instruments).map((instrument) => (
          <Shape
            active={value.instruments.includes(instrument.instrument)}
            onClick={() => changers.onInstrumentToggle(instrument.instrument)}
            key={instrument.instrument}
            shape="square"
            type="icon"
            text={instrument.name}
            textSize="small"
            theme="default"
            icon={instrument.icon}
            outline="thin"
            textOverflowBehavior="wrap"
          />
        ))}
      </motion.div>
    </MotionConfig>
  );
}
